/** @module path */ /** for typedoc */
export * from "./node";
export * from "./pathFactory";


/** WEBPACK FOOTER **
 ** ./path/module.ts
 **/